import ContextMenu from "./ContextMenu";
import useUserContextSubmenu from "./useUserContextSubmenu";
import G from './Getters';
import { useState } from 'react';
import A from './ActionCreators.js';
import { useStore, useDispatch } from 'react-redux';

export default function WorkspaceSelector(){

  const userContextSubmenu = useUserContextSubmenu() 

  const dispatch = useDispatch();

  const store = useStore();

  const state = store.getState();


  const [anchorEl, setAnchorEl] = useState(null);
  const [ open, setOpen ] = useState(false);

  const handleClick = (event) => {
    if( open ){ return; }
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };


  const currentWorkspace = G.getCurrentWorkspaceInfo(state);
  let { groupId, userId } = currentWorkspace;

  let groupName = groupId ?  G.getGroupName(state,groupId) : "My Space" ;


  let menuPos = {};
  if( anchorEl ){
    let r = anchorEl.getBoundingClientRect()
    menuPos = {
      x:r.x,
      y:r.y + r.height
    }
  }

  let menu = open && <ContextMenu onEvent={(item) => {

    item?.onClick?.();


  }}
    onClose={() => setOpen(false)}
    closeOnOutsideClick={true}
    roundCorners={true}
    globalStyle={{
      //paddingTop:5,
      paddingTop:5,
      paddingBottom:5,
      //paddingLeft:3,
      paddingRight:3,
      fontSize:18,
      background:'white',
      zIndex:100,
    }}
    //openPath={openPath}
    //setOpenPath={setOpenPath}
    //transform={'translate(-50%)'}
    x={menuPos.x + 20}
    y={menuPos.y}
    submenuDirection={"left"}
    items={userContextSubmenu}

  />

    return (

      <div style={{
        

        background:(
            open ? '#ccc' : 'none'
          )
      }}

        onClick={handleClick}
        class="sg-row v-center flex-expand">

        <div style={{
          paddingLeft:5,
          
        }} 
        >
          {groupName}
        </div>
        {menu}
      </div>
    )




}
